var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chip",class:{disabled: _vm.tagsInput.disabled}},[_c('div',[_vm._t("default")],2),(_vm.deletable)?_c('close-icon',{nativeOn:{"click":function($event){return _vm.onRemove.apply(null, arguments)}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }